import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 0a11.9 11.9 0 0 0-8.463 3.537 1.048 1.048 0 0 0 0 1.484l1.768 1.768a1.067 1.067 0 0 0 1.824-.742c0-.278-.11-.545-.308-.742l-.979-.979a9.67 9.67 0 0 1 5.147-2.115V3.6a1.042 1.042 0 1 0 2.085 0V2.21a10.01 10.01 0 0 1 5.147 2.148l-1.01.947a1.048 1.048 0 0 0 0 1.484 1.067 1.067 0 0 0 1.515 0l.98-.978a9.79 9.79 0 0 1 2.147 5.147h-1.39a1.042 1.042 0 0 0 0 2.084h1.39a9.79 9.79 0 0 1-2.148 5.116l-.979-.98a1.05 1.05 0 1 0-1.484 1.485l.98.98a9.79 9.79 0 0 1-5.148 2.178v-1.39a1.042 1.042 0 1 0-2.085 0v1.39a9.925 9.925 0 0 1-5.147-2.116l.98-.979a1.05 1.05 0 0 0-1.485-1.484l-1.769 1.769a.818.818 0 0 0-.22.347c-.152.39-.066.832.22 1.137A11.874 11.874 0 0 0 18.5 24c6.627 0 12-5.373 12-12s-5.373-12-12-12z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 6.032a1.052 1.052 0 0 0-1.042 1.042V12a1.052 1.052 0 0 0 1.042 1.042h4.2a1.042 1.042 0 0 0 0-2.084h-3.126V7.074A1.058 1.058 0 0 0 18.5 6.032zm-9.947 4.926h-7.01a1.042 1.042 0 0 0 0 2.084h7.01a1.042 1.042 0 0 0 0-2.084zm0-4.042h-4.61a1.042 1.042 0 1 0 0 2.084h4.61a1.042 1.042 0 0 0 0-2.084zm0 8.052h-4.61a1.042 1.042 0 1 0 0 2.085h4.61a1.042 1.042 0 1 0 0-2.085z"
});
var Express = function Express(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "31",
    height: "24",
    viewBox: "0 0 31 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: color,
    fillRule: "nonzero"
  }, _ref2, _ref3));
};
export default Express;